module.exports = __webpack_public_path__ + "img/F125.4e34ecfe.jpg";